import { StatisticsService } from '../services/StaticsService';
export class StatisticsPanelModel {
    // requestId is optional but if provided when requesting fetchStatistics the component will start by
    // checking the status instead of requesting latest count.
    //
    // noCountsGeneratedBefore when equals true the panel will start by showing nocount state instead of
    // checking right away
    //
    // justListen when set to true the component will initialize in the background and no panel will
    // popup but events will be emited
    constructor(clientId, detailId, targetElement, requestId = null, noCountsGeneratedBefore = false, justListen = false, forceRequest = false) {
        this.NO_COUNTS_GENERATED_BEFORE = false;
        this.JUST_LISTEN = false;
        this.FORCE_REQUEST = false;
        this.CLIENT_ID = clientId;
        this.DETAIL_ID = detailId;
        this.REQUEST_ID = requestId;
        this.TARGET_ELEMENT = targetElement;
        this.NO_COUNTS_GENERATED_BEFORE = noCountsGeneratedBefore;
        this.JUST_LISTEN = justListen;
        this.FORCE_REQUEST = forceRequest;
        if (requestId == null || requestId < 1) {
            this.STATISTICS_SERVICE = new StatisticsService(clientId, detailId);
        }
        else {
            this.STATISTICS_SERVICE = new StatisticsService(clientId, detailId, Number(requestId));
        }
    }
    get forceRequest() {
        return this.FORCE_REQUEST;
    }
    get justListen() {
        return this.JUST_LISTEN;
    }
    get clientId() {
        return this.CLIENT_ID;
    }
    get detailId() {
        return this.DETAIL_ID;
    }
    get requestId() {
        return this.REQUEST_ID;
    }
    set requestId(requestId) {
        this.REQUEST_ID = requestId;
        if (requestId == null) {
            this.STATISTICS_SERVICE.resetRequestId();
        }
        else {
            this.STATISTICS_SERVICE.requestId = Number(requestId);
        }
    }
    get requestIdSafe() {
        if (this.REQUEST_ID == null) {
            return -1;
        }
        return this.REQUEST_ID;
    }
    get noCountsGeneratedBefore() {
        return this.NO_COUNTS_GENERATED_BEFORE;
    }
    set noCountsGeneratedBefore(noCountsGeneratedBefore) {
        this.NO_COUNTS_GENERATED_BEFORE = noCountsGeneratedBefore;
    }
    get targetElement() {
        return this.TARGET_ELEMENT;
    }
    get statisticsService() {
        return this.STATISTICS_SERVICE;
    }
}
//# sourceMappingURL=StatisticsPanelModel.js.map